function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.object.define-properties.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utilities
import { mapState, mapGetters } from 'vuex';
import ApiService from '../../services/apiService';
export default {
  name: 'CoreFeedback',
  props: {
    feedbackDialog: {
      type: Boolean,
      required: false,
      "default": false
    },
    dialogTitle: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      formValid: false,
      formItem: {},
      bug: '0',
      formData: new FormData(),
      isLoading: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['color', 'inpOutlined', 'inpFilled'])), mapGetters({
    user: 'authentication/user',
    tenantId: 'authentication/tenantId'
  })), {}, {
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    requiredRule: function requiredRule() {
      var _this = this;
      return [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }];
    },
    version: function version() {
      return this.$store.state.app.packageVersion;
    },
    // title() {
    //   if (this.bug === '1') {
    //     return this.$i18n_t('Common.help.bugTitle');
    //   } else {
    //     if (this.type === 'suggestion') {
    //       return this.$i18n_t('Common.help.commitment');
    //     }
    //     return this.$i18n_t('Common.help.shortDescription');
    //   }
    // },
    feedback: function feedback() {
      if (this.type === 'suggestion') {
        return this.$i18n_t('Common.help.feedbackSuggestion');
      } else if (this.bug === '1') {
        return this.$i18n_t('Common.help.bugDescription');
      } else {
        return this.$i18n_t('Common.help.feedback');
      }
    },
    // description() {
    //   if (this.bug === '1') {
    //     return this.$i18n_t('Common.help.howReproduce');
    //   } else {
    //     if (this.type === 'suggestion') {
    //       return this.$i18n_t('Common.help.needItFor');
    //     }
    //     return this.$i18n_t('Common.help.description');
    //   }
    // },
    placeholder: function placeholder() {
      if (this.type === 'suggestion') {
        return this.$i18n_t('Common.help.placeholderSuggestion');
      }
      return this.$i18n_t('Common.help.placeholder');
    },
    buttons: function buttons() {
      return [{
        icon: 'fas fa-save',
        title: this.$i18n_t('Common.help.send'),
        type: 'submit'
      }, {
        icon: 'fal fa-times',
        color: 'danger',
        action: 'close',
        tooltip: this.$i18n_t('Common.cancel')
      }];
    }
  }),
  watch: {
    feedbackDialog: function feedbackDialog() {
      this.initData();
    }
  },
  created: function created() {
    this.initData();
  },
  methods: {
    initData: function initData() {
      if (this.feedbackDialog) {
        this.formItem['email'] = this.user.email;
        this.formItem['userId'] = this.user.id;
      }
    },
    createFormData: function createFormData() {
      var subject = this.formItem.title ? this.formItem.title : this.$i18n_t('Common.help.customerFeedback');
      this.formData.append('tenantId', this.tenantId);
      this.formData.append('userId', this.formItem.userId);
      this.formData.append('subject', subject);
      this.formData.append('content', this.createBody());
      if (this.bug === '1') {
        this.formData.append('bug', true);
      }
      this.send();
    },
    files: function files(_files) {
      var _this2 = this;
      this.formData = new FormData();
      if (_files.length > 1) {
        _files.forEach(function (file) {
          _this2.formData.append('attachment', file, file.name);
        });
      } else {
        this.formData.append('file', _files[0]);
      }
    },
    close: function close() {
      this.clear();
      this.$emit('close');
    },
    clear: function clear() {
      this.formItem = {};
      this.formData = new FormData();
      this.$refs.uploadMultiple.clear();
    },
    createBody: function createBody() {
      var body = "<h3>".concat(this.dialogTitle, "</h3>");
      if (this.type === 'like') {
        body += this.createDescription(this.formItem.description);
      }
      if (this.type !== 'like') {
        body += this.createDescription(this.formItem.title, this.formItem.description, this.formItem.feedback);
      }
      if (this.formItem.contact) {
        body += "<p>".concat(this.$i18n_t('Common.help.contactMe'), "</p>");
      }
      body += '<hr />';
      body += "<p>".concat(this.$i18n_t('Common.help.emailUser'), ": ").concat(this.formItem.email, "</p>");
      body += "<p>".concat(this.$i18n_t('Common.help.userId'), ": ").concat(this.formItem.userId, "</p>");
      body += "<p>".concat(this.$i18n_t('Common.help.systemVersion'), ": ").concat(this.version, "</p>");
      return body;
    },
    createDescription: function createDescription(text) {
      var text2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var text3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var content = '';
      if (text2 && text3) {
        content += "<b>".concat(this.$i18n_t('Common.help.titel'), "</b></br />");
        content += "<p>".concat(text, "</p></br>");
        content += "<b>".concat(this.$i18n_t('Common.description'), "</b></br>");
        content += "<p>".concat(text2, "</p></br>");
        content += "<b>".concat(this.$i18n_t('Common.help.detailedDescription'), "</b></br>");
        content += "<p>".concat(text3, "</p></br></br>");
      } else {
        content = "<b>".concat(this.$i18n_t('Common.description'), "</b></br>");
        content += "<p>".concat(text, "</p></br></br>");
      }
      return content;
    },
    send: function send() {
      var _this3 = this;
      this.isLoading = true;
      return ApiService.sendFeedback(this.formData).then(function () {
        _this3.$snack(_this3.$i18n_t('Common.help.feedbackSendSuccess'), 'success');
        _this3.$emit('close');
        _this3.clear();
      })["catch"](function (error) {
        if (error.response && _this3.$i18n_t("Error.".concat(error.response.data.message))) {
          _this3.$snack(_this3.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this3.$snack(_this3.$i18n_t('Common.help.sendingError'), 'error');
        }
        throw error;
      })["finally"](function () {
        return _this3.isLoading = false;
      });
    },
    clearFiles: function clearFiles() {
      this.formData["delete"]('attachment');
      this.formData["delete"]('file');
    }
  }
};